import { render, staticRenderFns } from "./imoprtAndHandle.vue?vue&type=template&id=9414fe04&scoped=true&lang=true"
import script from "./imoprtAndHandle.vue?vue&type=script&lang=js"
export * from "./imoprtAndHandle.vue?vue&type=script&lang=js"
import style0 from "./imoprtAndHandle.vue?vue&type=style&index=0&id=9414fe04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9414fe04",
  null
  
)

export default component.exports